import React from "react";

import { Link } from "react-router-dom";

import { Button } from "reactstrap";

const Page404 = () => {
  
  return (  
  <div className="text-center">
    <h1 className="display-1 font-weight-bold">404</h1>
    <p className="h1">Page non trouvee.</p>
    <p className="h2 font-weight-normal mt-3 mb-4">
      La page que vous cherchez a du etre supprimee.
    </p>
    <Link to="/dashboard/default">
      <Button color="primary" size="lg">
        Retour a la page principale
      </Button>
    </Link>
  </div>
)};

export default Page404;
